import { NeoState } from '../Reducers.interface';
import { createSelector } from 'reselect';
import { BookingStatus, IBookingSimple } from '~/Models/DTO/Booking.models';

export const selectBookingsList = (state: NeoState) => state.bookings.list;

export const selectBookedListLength = createSelector(
  selectBookingsList,
  (bookings) =>
    bookings.filter((booking: IBookingSimple) => booking.status === BookingStatus.BOOKED).length,
);

export const selectBookingsByEventId = (eventUuid: string) =>
  createSelector(selectBookingsList, (bookings) =>
    bookings.filter((booking: IBookingSimple) => booking.event.uuid === eventUuid),
  );
